import { render, staticRenderFns } from "./IqcList.vue?vue&type=template&id=2190ef5a"
import script from "./IqcList.vue?vue&type=script&lang=js"
export * from "./IqcList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports